import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Create root
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);